module.exports = __webpack_public_path__ + "static/media/close-circle-white.3e54120a.svg";